import { useEffect, useState } from 'react';
import {
  Box,
  TextareaAutosize,
  Button,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { toast } from 'react-toastify';
import { Loading } from '../Loading';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterGetDiagnosticProps {
  cpeId: string;
  onSubmit: () => void;
}

export const RouterGetDiagnostic = ({ cpeId,  onSubmit }: RouterGetDiagnosticProps) => {

  const [result, setResult] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let isCalled = false;
  const api = useApi();

  const getDiagnostic = useMutation(api.runHealthCheckApiV1RunHealthCheckGet, {
    onSuccess: (res) => {
      const parsedData = JSON.parse(res.data);
      setResult(JSON.stringify(parsedData, null, 2));
      setIsLoading(false);
      toast.success('Diagnostics collected successfully.');
    },
    onError(error: any) {
      setIsLoading(false);
      apiError(error);
    },
  });

  const handleSubmit = () => {
    onSubmit();
  };

  const handleDownload = () => {
    try {
      if (!result) {
        throw new Error('No diagnostic data available to download.');
      }
      const blob = new Blob([result], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Diagnostic-${cpeId}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toast.success('Downloaded successfully!');
    } catch (error: any) {
      toast.error(error?.message || 'Download failed.');
    }
  };

  useEffect(() => {
    if (cpeId) {
      setIsLoading(true);
      !isCalled && getDiagnostic.mutate({node_id: cpeId});
      isCalled = true;
    }
  }, [cpeId]);

  return (
    <Box pt={2}>
      {isLoading ? <Loading />:
        <TextareaAutosize
          style={{ width: '100%' }}
          minRows={15}
          value={result}
          readOnly
        />
      }
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant='outlined' sx={{mr: 5}} onClick={handleDownload}>
          Download
        </Button>
        <Button variant="outlined" onClick={handleSubmit}>
          Close
        </Button>
      </Box>
    </Box>
  );
};
